import { useMemo, useState } from 'react';
import { apiRequest } from '../apiClient';
import { buildUiHelpers } from './sharedUi';
import { NEWSLETTER_CONSENT_TEXT, NEWSLETTER_CONSENT_VERSION } from './newsletterConsent';
import './PublicNewsletterForm.css';

export default function PublicNewsletterForm({ COLORS, inputStyle }) {
  const { Btn } = useMemo(() => buildUiHelpers({ COLORS, th: {} }), [COLORS]);
  const [email, setEmail] = useState('');
  const [mode, setMode] = useState('subscribe');
  const [consent, setConsent] = useState(true);
  const [website, setWebsite] = useState('');
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  async function submit(event) {
    event.preventDefault();
    if ((mode === 'subscribe' && !consent) || busy) return;
    setBusy(true);
    setError('');
    try {
      const data = await apiRequest(mode === 'subscribe' ? '/api/newsletter/subscribe' : '/api/newsletter/unsubscribe-request', {
        method: 'POST', auth: false, timeoutMs: 30000,
        body: mode === 'subscribe'
          ? { email: email.trim(), consent, consent_version: NEWSLETTER_CONSENT_VERSION, website }
          : { email: email.trim(), website },
      });
      setMessage(data.message);
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  }

  return <>
    <h2 style={{ margin: '0 0 18px', fontSize: 18, color: COLORS.text }}>Newsletter</h2>
    <fieldset disabled={busy} style={{ display: 'flex', gap: 8, border: 0, padding: 0, margin: '0 0 22px', minWidth: 0 }} aria-label="Newsletter-Aktion">
      {[['subscribe', 'Anmelden'], ['unsubscribe', 'Abmelden']].map(([value, label]) => (
        <label className="newsletter-mode-option" key={value} style={{ flex: 1, position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '8px 10px', borderRadius: 8, background: mode === value ? COLORS.accent : '#ffffff08', color: mode === value ? '#fff' : COLORS.muted, cursor: busy ? 'default' : 'pointer', fontSize: 13, fontWeight: 600 }}>
          <input type="radio" name="newsletter-action" value={value} checked={mode === value} onChange={() => { setMode(value); setMessage(''); setError(''); }} />
          {label}
        </label>
      ))}
    </fieldset>
    {message ? <p role="status" style={{ color: COLORS.text, fontSize: 14, lineHeight: 1.7 }}>{message}</p> : (
      <form onSubmit={submit}>
        <label htmlFor="newsletter-email" style={{ fontSize: 12, color: COLORS.muted, display: 'block', marginBottom: 6 }}>E-Mail-Adresse</label>
        <input id="newsletter-email" type="email" autoComplete="email" required maxLength={254} placeholder="name@beispiel.de" value={email} disabled={busy} onChange={e => setEmail(e.target.value)} style={inputStyle} />
        <div hidden aria-hidden="true">
          <label>Website<input name="website" autoComplete="off" tabIndex={-1} value={website} onChange={e => setWebsite(e.target.value)} /></label>
        </div>
        {mode === 'subscribe' && <label style={{ display: 'flex', alignItems: 'flex-start', gap: 8, fontSize: 13, lineHeight: 1.5, marginBottom: 18, color: COLORS.text }}>
          <input type="checkbox" required checked={consent} disabled={busy} onChange={e => setConsent(e.target.checked)} />
          <span>{NEWSLETTER_CONSENT_TEXT} <a href="https://www.einfach-trading.de/rechtliches.html" target="_blank" rel="noreferrer" style={{ color: COLORS.cyan }}>Datenschutz</a></span>
        </label>}
        {error && <p role="alert" style={{ color: COLORS.red, fontSize: 13 }}>{error}</p>}
        <Btn type="submit" disabled={busy || (mode === 'subscribe' && !consent)} style={{ width: '100%' }}>{busy ? 'Wird gesendet...' : mode === 'subscribe' ? 'Zum Newsletter anmelden' : 'Abmeldelink anfordern'}</Btn>
      </form>
    )}
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 16, marginTop: 18, fontSize: 13 }}>
      {message && <button type="button" onClick={() => { setMessage(''); setConsent(true); }} style={{ background: 'transparent', border: 0, padding: 0, font: 'inherit', color: COLORS.cyan, cursor: 'pointer' }}>Zurück zum Formular</button>}
      <a href="/" style={{ color: COLORS.cyan }}>Zum Login</a>
    </div>
  </>;
}
